import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useEffect } from "react";
function AdminLogin() {

const navigate = useNavigate();

const [loading, setLoading] = useState(false);

const [formData, setFormData] = useState({
name: "",
password: ""
});
useEffect(() => {

  const token =
    localStorage.getItem(
      "ekyaAdminToken"
    );

  if (token) {
    window.location.href =
      "/dashboard";
  }

}, []);
const handleChange = (e) => {
setFormData({
...formData,
[e.target.name]: e.target.value
});
};

const handleSubmit = async (e) => {


e.preventDefault();

try {

  setLoading(true);

  const res = await axios.post(
    "https://ekya-backend.onrender.com/api/admin/login",
    formData
  );

  localStorage.setItem(
    "ekyaAdminToken",
    res.data.token
  );

  Swal.fire({
    icon: "success",
    title: "Login Successful",
    text: "Welcome back to EKYA Admin Dashboard",
    confirmButtonText: "Continue"
  });

  navigate("/dashboard");

} catch (error) {

  Swal.fire({
    icon: "error",
    title: "Login Failed",
    text:
      error.response?.data?.message ||
      "Something went wrong"
  });

} finally {

  setLoading(false);

}


};

return ( <div className="min-h-screen bg-[#F8F5F0] flex items-center justify-center px-6">


  <motion.div
    initial={{
      opacity: 0,
      y: 30
    }}
    animate={{
      opacity: 1,
      y: 0
    }}
    className="bg-white w-full max-w-md rounded-3xl shadow-xl p-10"
  >

    <h1 className="text-4xl font-bold text-center mb-3">
      Admin Login
    </h1>

    <p className="text-center text-gray-500 mb-8">
      EKYA Dashboard Access
    </p>

    <form
      onSubmit={handleSubmit}
      className="space-y-5"
    >

      <input
        type="name"
        name="name"
        placeholder="Name"
        value={formData.email}
        onChange={handleChange}
        required
        className="w-full border p-4 rounded-xl"
      />

      <input
        type="password"
        name="password"
        placeholder="Password"
        value={formData.password}
        onChange={handleChange}
        required
        className="w-full border p-4 rounded-xl"
      />

      <button
        type="submit"
        disabled={loading}
        className="w-full bg-black text-white py-4 rounded-xl font-semibold"
      >
        {loading ? "Signing In..." : "Login"}
      </button>

    </form>

  </motion.div>

</div>


);
}

export default AdminLogin;
